module.exports = {
      id: "target-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#target-usage",
      toString: function () {
        return this.url;
      }
    }